module.exports = __webpack_public_path__ + "img/intro_8.7c7da13b.jpeg";